import { LedgerForm } from "../../LedgerForm";

export const TransferPayment = ({
  storeDetails,
  isRequired = false,
  errorMessage,
}) => {
  return (
    <section>
      <h5>Transfer Payment</h5>
      <p className="small-text-size mb-3" style={{ maxWidth: "450px" }}>
        Kindly confirm you have received the total amount in the payment summary
      </p>

      {storeDetails?.allow_chart_account_selection_on_checkout ? (
        <LedgerForm isRequired={isRequired} errorMessage={errorMessage} />
      ) : null}
    </section>
  );
};
